// extracted by mini-css-extract-plugin
module.exports = {"idea":"styles_idea__2jyvN"};